<template>
  <section id="kontakt" class="contact section">
    <div class="container">
      <div class="section-header" data-aos="fade-up">
        <h2>Kontakt</h2>
        <div class="section-line"></div>
        <p>Skontaktuj się z nami z pomocą poniższego formularza. Odpowiemy na każde pytanie dotyczące naszych usług i produktów.</p>
      </div>
      
      <div class="contact-content">
        <div class="contact-info" data-aos="fade-right">
          <div class="info-item">
            <div class="info-icon">📞</div>
            <div>
              <h3>Telefon</h3>
              <p><a href="tel:+48570422020">+48 570 422 020</a></p>
            </div>
          </div>
          
          <div class="info-item">
            <div class="info-icon">✉️</div>
            <div>
              <h3>Email</h3>
              <p><a href="mailto:kontakt@vi-gas.pl">kontakt@vi-gas.pl</a></p>
            </div>
          </div>
          
          <div class="info-item">
            <div class="info-icon">🕒</div>
            <div>
              <h3>Godziny pracy</h3>
              <p>Pon-Pt: 9:00 - 16:00<br>Sobota: 10:00 - 14:00</p>
            </div>
          </div>
        </div>
        
        <div class="contact-form" data-aos="fade-left">
          <form @submit.prevent="submitForm" :class="{ 'loading': isLoading }">
            <div class="form-group">
              <label for="address">Adres</label>
              <input 
                type="text" 
                id="address" 
                v-model="form.address" 
                required
                placeholder="Wprowadź adres instalacji"
              >
            </div>
            
            <div class="form-group">
              <label for="boilerType">Typ Kotła</label>
              <select id="boilerType" v-model="form.boilerType" required>
                <option value="">Wybierz typ kotła</option>
                <option value="vitodens">Vitodens</option>
                <option value="vitopend">Vitopend</option>
                <option value="przemysłowy">Kotły przemysłowe</option>
                <option value="pompa-ciepła">Pompa ciepła</option>
                <option value="inne">Inne</option>
              </select>
            </div>
            
            <div class="form-group">
              <label for="phone">Telefon</label>
              <input 
                type="tel" 
                id="phone" 
                v-model="form.phone" 
                required
                placeholder="+48 570 422 020"
              >
            </div>
            
            <div class="form-group">
              <label for="description">Opis Awarii</label>
              <textarea 
                id="description" 
                v-model="form.description" 
                required
                rows="5"
                placeholder="Opisz szczegółowo problem z urządzeniem..."
              ></textarea>
            </div>

            <div class="form-group checkbox-group">
              <label class="checkbox-label" for="privacyConsent">
                <input
                  type="checkbox"
                  id="privacyConsent"
                  v-model="form.privacyConsent"
                  required
                >
                <span>
                  Wyrażam zgodę na przetwarzanie moich danych osobowych w celu obsługi zgłoszenia serwisowego, zgodnie z
                  RODO oraz <router-link :to="{ name: 'PrivacyPolicy' }">Polityką prywatności i cookies</router-link>.
                </span>
              </label>
            </div>

            <p class="privacy-note">Dane podane w formularzu zgłoszeniowym są przetwarzane zgodnie z RODO wyłącznie po to, abyśmy mogli obsłużyć Twoje zgłoszenie serwisowe. Podanie danych jest dobrowolne, ale niezbędne do udzielenia odpowiedzi.</p>
            
            <button type="submit" class="btn submit-btn" :disabled="isLoading">
              <span v-if="isLoading">Wysyłanie...</span>
              <span v-else>Wyślij zgłoszenie</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue'
import { supabase } from '../services/supabase'
import { sendServiceRequestEmail } from '../services/emailService'

export default {
  name: 'ContactSection',
  setup() {
    const isLoading = ref(false)
    
    const form = ref({
      address: '',
      boilerType: '',
      phone: '',
      description: '',
      privacyConsent: false
    })
    
    const submitForm = async () => {
      isLoading.value = true
      
      try {
        // Prepare request data
        const requestData = {
          address: form.value.address,
          boiler_type: form.value.boilerType,
          phone: form.value.phone,
          description: form.value.description,
          status: 'new',
          created_at: new Date().toISOString()
        }
        
        // Save to Supabase
        const { error } = await supabase
          .from('service_requests')
          .insert([requestData])
        
        if (error) throw error
        
        // Send email notification
        try {
          await sendServiceRequestEmail(requestData)
          console.log('Email notification sent successfully')
        } catch (emailError) {
          console.error('Failed to send email notification:', emailError)
          // Continue even if email fails - request is already saved
        }
        
        alert('Zgłoszenie zostało wysłane pomyślnie!')
        
        // Reset form
        form.value = {
          address: '',
          boilerType: '',
          phone: '',
          description: '',
          privacyConsent: false
        }
        
      } catch (error) {
        console.error('Error submitting form:', error)
        alert('Wystąpił błąd podczas wysyłania zgłoszenia. Spróbuj ponownie.')
      } finally {
        isLoading.value = false
      }
    }
    
    return {
      form,
      isLoading,
      submitForm
    }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    color: white;
    font-size: 2.5rem;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    margin: 0 auto 20px;
    border-radius: 2px;
  }
  
  p {
    font-size: 1.1rem;
    opacity: 0.9;
    max-width: 600px;
    margin: 0 auto;
  }
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
}

.contact-info {
  .info-item {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    
    .info-icon {
      font-size: 2rem;
      min-width: 60px;
    }
    
    h3 {
      margin-bottom: 10px;
      font-size: 1.2rem;
    }
    
    p {
      opacity: 0.9;
      line-height: 1.6;
      
      a {
        color: #FFD93D;
        text-decoration: none;
        font-weight: 600;
        
        &:hover {
          color: white;
        }
      }
    }
    
    .service-note {
      color: #FFD93D;
      font-weight: 600;
      margin-top: 5px;
    }
  }
}

.contact-form {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  
  &.loading {
    opacity: 0.7;
    pointer-events: none;
  }
}

.form-group {
  margin-bottom: 25px;
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: white;
  }
  
  input, select, textarea {
    width: 100%;
    padding: 12px 15px;
    border: none;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    transition: all 0.3s ease;
    
    &:focus {
      outline: none;
      background: white;
      box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.3);
    }
    
    &::placeholder {
      color: #999;
    }
  }
  
  textarea {
    resize: vertical;
    min-height: 120px;
  }
}

.checkbox-group {
  margin-top: 10px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-weight: 400 !important;
  line-height: 1.5;

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    margin-top: 2px;
  }

  a {
    color: #FFD93D;
    text-decoration: underline;
  }
}

.submit-btn {
  width: 100%;
  padding: 15px;
  font-size: 1.1rem;
  margin-top: 10px;
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

@media (max-width: 768px) {
  .contact-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .contact-form {
    padding: 30px 20px;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
}
</style>